import React from 'react'

interface LoadingProps {
  size?: 'sm' | 'md'
  children?: React.ReactNode
}

export function Loading({ size = 'sm', children }: LoadingProps) {
  const sizeClass = size === 'sm' ? 'w-6 h-6' : 'w-8 h-8'

  return (
    <div className="flex gap-x-2 items-center">
      <img className={sizeClass} src="/images/icon-jump-animated.svg" />
      {children && <div className="text-secondary">{children}</div>}
    </div>
  )
}
